module.exports = __webpack_public_path__ + "static/img/device-operation.34a0006.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/device-operation.png
// module id = 7Dww
// module chunks = 1